

export function toAdjacentPairs<T>(list: T[]): [T, T][] {
    const result: [T, T][] = [];
    for (let i = 0; i < list.length - 1; i++) {
        result.push([list[i], list[i + 1]]);
    }
    return result;
}
